import { ModalTypes } from 'application/providers/ModalProvider/consts';

import { DeviceTypes } from '@shared/api/graphql/generated';

import { TEXTS } from './texts';
import { DeviceTypesInFlow, PlayerTypesInFlow, VideoDeviceType } from '../types';
import { TPlayerTypeItem } from './types';

const WEB_PLAYER_IMAGE = '/assets/img/select_player_flow/web.png';
const MOBILE_AUDIO_PLAYER_IMAGE = '/assets/img/select_player_flow/mobile_audio.png';
const MOBILE_VIDEO_PLAYER_IMAGE = '/assets/img/select_player_flow/mobile_video.png';
const DESKTOP_PLAYER_IMAGE = '/assets/img/select_player_flow/desktop.png';
const BOOM_SPEAKER_PLAYER_IMAGE = '/assets/img/select_player_flow/sberboom.png';
const ANDROID_BOX_PLAYER_IMAGE = '/assets/img/select_player_flow/desktop_box.png';
const VIDEO_PLAYER_BOX_PLAYER_IMAGE = '/assets/img/select_player_flow/tv_video.png';
const AUDIO_PLAYER_BOX_PLAYER_IMAGE = '/assets/img/select_player_flow/tv_audio.png';

export const DEVICES_IN_FLOW = [
  DeviceTypes.Android,
  DeviceTypes.Androidbox,
  DeviceTypes.BoomSpeaker,
  DeviceTypes.Desktop,
  DeviceTypes.Ios,
  DeviceTypes.Webplayer,
];

export const DEVICE_TO_PLAYER_TYPE: Record<DeviceTypesInFlow | VideoDeviceType, PlayerTypesInFlow> = {
  [DeviceTypes.Android]: PlayerTypesInFlow.MOBILE,
  [DeviceTypes.Androidbox]: PlayerTypesInFlow.ANDROIDBOX,
  [DeviceTypes.BoomSpeaker]: PlayerTypesInFlow.BOOM_SPEAKER,
  [DeviceTypes.Desktop]: PlayerTypesInFlow.DESKTOP,
  [DeviceTypes.Ios]: PlayerTypesInFlow.MOBILE,
  [DeviceTypes.Webplayer]: PlayerTypesInFlow.WEBPLAYER,
  [VideoDeviceType.Video]: PlayerTypesInFlow.VIDEOPLAYER,
};

export const PLAYER_TO_DEVICE_TYPE: Record<PlayerTypesInFlow, DeviceTypesInFlow | VideoDeviceType> = {
  [PlayerTypesInFlow.MOBILE]: DeviceTypesInFlow.ANDROID,
  [PlayerTypesInFlow.ANDROIDBOX]: DeviceTypesInFlow.ANDROIDBOX,
  [PlayerTypesInFlow.BOOM_SPEAKER]: DeviceTypesInFlow.BOOM_SPEAKER,
  [PlayerTypesInFlow.DESKTOP]: DeviceTypesInFlow.DESKTOP,
  [PlayerTypesInFlow.WEBPLAYER]: DeviceTypesInFlow.WEBPLAYER,
  [PlayerTypesInFlow.VIDEOPLAYER]: VideoDeviceType.Video,
};

export const PLAYER_TEXT_TYPE: Record<PlayerTypesInFlow, Omit<TPlayerTypeItem, 'type'>> = {
  [PlayerTypesInFlow.WEBPLAYER]: {
    title: TEXTS.WEBPLAYER_TITLE,
    description: TEXTS.WEBPLAYER_DESCRIPTION,
    imageSrc: WEB_PLAYER_IMAGE,
  },
  [PlayerTypesInFlow.MOBILE]: {
    title: TEXTS.MOBILE_TITLE,
    description: TEXTS.MOBILE_AUDIO_DESCRIPTION,
    descriptionFallback: TEXTS.MOBILE_VIDEO_DESCRIPTION,
    imageSrc: MOBILE_VIDEO_PLAYER_IMAGE,
    imageSrcFallback: MOBILE_AUDIO_PLAYER_IMAGE,
  },
  [PlayerTypesInFlow.DESKTOP]: {
    title: TEXTS.DESKTOP_TITLE,
    description: TEXTS.DESKTOP_DESCRIPTION,
    imageSrc: DESKTOP_PLAYER_IMAGE,
  },
  [PlayerTypesInFlow.ANDROIDBOX]: {
    title: TEXTS.SBER_BUSINESS_PLAYER_TITLE,
    description: TEXTS.SBER_BUSINESS_PLAYER_DESCRIPTION,
    imageSrc: ANDROID_BOX_PLAYER_IMAGE,
    ruByOnly: true,
  },
  [PlayerTypesInFlow.BOOM_SPEAKER]: {
    title: TEXTS.BOOM_SPEAKER_TITLE,
    description: TEXTS.BOOM_SPEAKER_DESCRIPTION,
    imageSrc: BOOM_SPEAKER_PLAYER_IMAGE,
    ruByOnly: true,
  },
  [PlayerTypesInFlow.VIDEOPLAYER]: {
    title: TEXTS.VIDEO_PLAYER_TITLE,
    description: TEXTS.VIDEO_PLAYER_DESCRIPTION,
    imageSrc: VIDEO_PLAYER_BOX_PLAYER_IMAGE,
    imageSrcFallback: AUDIO_PLAYER_BOX_PLAYER_IMAGE,
  },
};

export const PLAYER_NAME_TYPE: Record<DeviceTypes | VideoDeviceType, string> = {
  [DeviceTypes.AliceSpeaker]: TEXTS.ALICE_TITLE,
  [DeviceTypes.Android]: TEXTS.ANDROID_TITLE,
  [DeviceTypes.Androidbox]: TEXTS.SBER_BUSINESS_PLAYER_TITLE,
  [DeviceTypes.BoomSpeaker]: TEXTS.BOOM_SPEAKER_TITLE,
  [DeviceTypes.Desktop]: TEXTS.DESKTOP_TITLE,
  [DeviceTypes.Desktopbox]: TEXTS.RPI_TITLE,
  [DeviceTypes.Ios]: TEXTS.MOBILE_TITLE,
  [DeviceTypes.Musicbox]: TEXTS.MUSICBOX_TITLE,
  [DeviceTypes.Netcore]: TEXTS.NETCORE_TITLE,
  [DeviceTypes.Webplayer]: TEXTS.WEBPLAYER_TITLE,
  [DeviceTypes.Pavo]: TEXTS.PAVO_TITLE,
  [VideoDeviceType.Video]: TEXTS.VIDEO_PLAYER_TITLE,
};

export const MODAL_MODE_BY_DEVICE_TYPE: Record<PlayerTypesInFlow, ModalTypes> = {
  [PlayerTypesInFlow.WEBPLAYER]: ModalTypes.STREAM_BIND_SUCCESS,
  [PlayerTypesInFlow.MOBILE]: ModalTypes.MOBILE_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.DESKTOP]: ModalTypes.DESKTOP_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.ANDROIDBOX]: ModalTypes.SBERBUSSINESS_REQUEST,
  [PlayerTypesInFlow.BOOM_SPEAKER]: ModalTypes.SBERBOOM_REQUEST,
  [PlayerTypesInFlow.VIDEOPLAYER]: ModalTypes.CHOOSE_VIDEO_PLAYER,
};
